export const QUOTE_STATE = 'QUOTE_STATE';
export const PRODUCTION_STATE = 'PRODUCTION_STATE';
export const TEMPLATE_STATE = 'TEMPLATE_STATE';
export const PENDING_STATE = 'PENDING_STATE';
export const COMPLETE_STATE = 'COMPLETE_STATE';
export const ITEM_COMPLETE_STATE = 'ITEM_COMPLETE_STATE';
export const VOID_STATE = 'VOID_STATE';
export const IN_PROGRESS_STATE = 'IN_PROGRESS_STATE';
export const AFTER_APPROVAL_STATE = 'AFTER_APPROVAL_STATE';
